import store from "venuescanner-js/utils/storeWithCompression";

export default function persistToStore(values) {
  if (!store) {
    console.warn("VS: undefined store!");
    return;
  }

  Object.entries({
    "enq-short-start-date": values.start_date?.format("DD/MM/YYYY"),
    "enq-short-end-date": values.end_date?.format("DD/MM/YYYY"),
    "start-hour": values.start_time && values.start_time.split(":")[0],
    "end-hour": values.end_time && values.end_time.split(":")[0],
    "enq-flexible": values.flexible,
    "enq-tags": values.eventType?.label,
    // 'enq-guests': values.guests, TODO: How can we populate the form if it's a range?
    "enq-budget-from": values.budget?.[0],
    "enq-budget-to": values.budget?.[1],
  }).forEach(([k, v]) => store.set(k, v));
}
